export const noFooterList = [
  "/bd",
  "/baidu",
  "/geo",
  "/dxaqy",
  "/tieba",
  "/bdAboutUs",
  "/bdproductInfo",
  "/bdpermit",
  "/bdsoftwareLis",
  "/bdprivacy",
  "/360m",
  "/namim",
  "/yykp",
  "/yyzb",
  "/jiayinwangyixinwen",
  "/jiayinwangyiyunyinyue",
  "/jyaiqiyi",
  "/dxaiqiyi",
  "/wangyiyixiao",
  "/kuaishou",
  "/360m/001",
  "/m996",
  "/msougou1",
  "/wm",
  "/zdzm",
  "/uc3",
  "/uc4",
  "/msougou2",
  "/gt",
  "/wb/996",
  "/ibaidu",
  "/sougou2",
  "/sougou3",
  "/yx3605",
  "/sigmob1",
  "/baidu9",
  "/yunyouhuaijiu",
  "/yunyoutianxia",
  "/dydr-yunyou",
  "/yx3607",
  "/yx3606",
  "/baidutieba",
  "/uc1",
  "/zb1",
  "/zb2",
  "/zb3",
  "/zb4",
  "/zb5",
  "/fb1",
  "/fb2",
  "/bdfb",
  "/biyingjjfb",
  "/lx",
  "/fb/gameDetail",
  "/sw",
  "/sw/gameDetail",
  "/dx",
  "/kszb",
  "/fengchaom",
  "/baiduwangpan",
  "/haokanshipin",
  "/lhfs",
  "/pddh",
  "/bym",
  "/siyu",
  "/siyu1",
  "/xunlei",
  "/ks",
  "/lhws",
  "/cqbz",
  "/zzzj"
];
